import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Package, FileDown } from 'lucide-react';
import api from '../../utils/api';
import { CourierShell, C } from '../../components/courier/CourierUI';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const hasToken = () => !!localStorage.getItem('tekstar_token');

export default function CourierMyShipments() {
  const nav = useNavigate();
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hasToken()) { setLoading(false); return; }
    api.get('/courier/shipments/my').then(({ data }) => setShipments(data.shipments)).finally(() => setLoading(false));
  }, []);

  if (!hasToken()) {
    return (
      <CourierShell>
        <div className="text-center py-20" data-testid="myshipments-login-prompt">
          <Package className="h-10 w-10 mx-auto text-black/30 mb-3" />
          <p className="font-black text-xl">Sign in to see your shipments</p>
          <Link to="/login" className="inline-block mt-4 px-6 py-3 rounded-xl font-black text-black" style={{ background: C.yellow }}>Sign In</Link>
        </div>
      </CourierShell>
    );
  }

  return (
    <CourierShell>
      <h1 className="text-3xl font-black mb-6">My Shipments</h1>
      {loading ? <p className="text-black/50">Loading…</p> : shipments.length === 0 ? (
        <div className="text-center py-16 text-black/40" data-testid="myshipments-empty">No shipments yet.</div>
      ) : (
        <div className="space-y-3" data-testid="myshipments-list">
          {shipments.map((s) => (
            <div key={s.id} className="bg-white rounded-xl p-4 border border-black/5 flex items-center justify-between gap-4">
              <div>
                <p className="font-mono font-black">{s.awb}</p>
                <p className="text-sm text-black/60">{s.origin?.zoneName} → {s.destination?.zoneName} · {s.serviceName}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="px-3 py-1 rounded-full text-xs font-black" style={{ background: C.yellow }}>{(s.status || '').replace(/_/g, ' ').toUpperCase()}</span>
                <a href={`${BACKEND}/api/courier/shipments/${s.id}/label.pdf`} target="_blank" rel="noreferrer" className="p-2 rounded-lg border border-black/10" title="Label"><FileDown className="h-4 w-4" /></a>
                <button onClick={() => nav(`/courier/track/${s.awb}`)} className="px-3 py-2 rounded-lg font-bold text-sm border border-black/15">Track</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CourierShell>
  );
}
